import Vue from 'vue'
import App from './App.vue'

//引入store
import store from './store'
//引入router
import router from './router/index'
//引入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';  ////使用https://unpkg.com/element-ui/lib/theme-chalk/index.css

import './assets/css/reset.css'
// import 'bootstrap/dist/css/bootstrap.css' //使用public文件夹的bootstrap.css

//引入全局对象
import {httpURL} from './utils/globalconfig'

Vue.use(ElementUI);


Vue.config.productionTip = false
//在vue上创建全局对象httpURL
Vue.prototype.httpURL = httpURL

new Vue({
  // el:'#app',
  store,
  router:router,
  render: h => h(App),
  created(){
    // store.commit('addMenu', router)
    // router.push('/home')  //刷新就显示首页
  },
  beforeCreate(){
    Vue.prototype.$bus = this  //全局安装事件总线，$bus就是当前应用的vm
}
}).$mount('#app')
